<script>
import VueBarcode from 'vue-barcode'
export default {
  name: 'PopupCarrier',
  components: {
    barcode: VueBarcode,
  },
  props: {
    data: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    closePopup() {
      this.$emit('update:modelValue', false);
    },
  },
  mounted() {},
  computed: {},
  watch: {},
}
</script>

<template>
  <transition name="fade" appear>
    <div class="wrapper2">
      <div class="wrapper" @click="closePopup"></div>
      <div class="popup">
        <section id="frame">
          <img
            style="position: absolute; top: 0; left: 0; width: 100%; z-index: -1"
            src="@/assets/images/popupcarrier.png"
            alt=""
          />
          <div class="member">會員條碼</div>
          <div class="close" @click="closePopup">
            <img src="@/assets/images/homeclose.png" alt="">
          </div>
          <div class="bar">
            <barcode
              :value="data"
              :text="data"
              height="72px"
              fontSize="14"
              font="Noto Sans TC"
              fontOptions="regular"
              textMargin="6"
              :margin="1"
              :margin-right="20"
              :margin-left="20"
              :format="'CODE128'"
              :option="{ width: '100px', height: '50px' }"
              background="transparent"
              style="
                display: flex;
                justify-content: center;
                transform-origin: center center;
                font-family: Noto Sans TC;
                font-weight: 400;
                border-radius: 14px;
                background-color: transparent;
              "
            >
              Show this if the rendering fails.
            </barcode>
          </div>
        </section>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.wrapper2 {
  touch-action: manipulation;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  // background-color: #0D0C0CB2;
  z-index: 9998;
}
.wrapper2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #0d0c0cb2;
  z-index: 9998;
}
.popup {
  position: absolute;
  // overflow: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  width: 312px;
  min-height: 336px;
  display: flex;
  border-radius: 18px;
  box-shadow: 1px 1px 4px -2px #4b25181f;
  z-index: 9998;
}
#frame {
  font-family: Noto Sans TC;
  position: relative;
  width: 100%;
  & img {
    border-radius: 18px 18px 0px 0px;
  }
  & .member {
    position: absolute;
    top: 35%;
    left: 24px;
    transform: translate(0%, -100%);
    font-weight: 900;
    color: #fff;
    font-size: 18px;
    line-height: 21.6px;
    letter-spacing: 4%;
  }
  & .bar {
    position: absolute;
    bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    left: 50%;
    transform: translate(-50%, 0%);
    width: calc(100% - 46px);
    background-color: #fff;
    border-radius: 14px;
    padding: 16px 0px 12px 0px;
    font-size: 14px;
    box-shadow: 1px 1px 4px -2px #4b251849, -1px 2px 10px -2px #4b25183d;

  }
  & .close {
    width: 100%;
    height: 100%;
    & img{
      position: absolute;
      left: 50%;
      top: 100%;
      transform: translate(-50%, 20px);
      width: 30px;
      height: 30px;
    }
  }
}
</style>
